function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.7.2@@babel/runtime/helpers/nonIterableSpread.js
// module id = 300
// module chunks = 0 1 2